import styled from "styled-components"

const CircleProgress = styled.div`
  margin: ${props => props.theme.timeline.transfer.margin}px;
  width: ${props =>
    props.theme.timeline.transfer.width -
    props.theme.timeline.transfer.borderWidth * 2}px;
  height: ${props =>
    props.theme.timeline.transfer.width -
    props.theme.timeline.transfer.borderWidth * 2}px;
  position: absolute;
  border-radius: 50%;

  & svg {
    width: 100%;
    overflow: hidden;
  }

  & path {
    fill-opacity: 0.8;
    fill: ${props => props.theme.color.highlightLight};
  }
`

export default CircleProgress
